<template>
  <panel-main-template>
    <template v-slot:page-title>Служба поддержки</template>
    <template v-slot:page-info>
      Мы стараемся ориентироваться на ваши пожеления. Возникли сложности при работе с сервисом?
      Не хватает какого-либо функционала? Заметили ошибку? Пишите, ваше обращение не останется без внимания.<br>
      График работы поддержки: 9:00 - 23:00 по МСК. Время ответа зависит от загруженности, но не превышает 24 часа
    </template>
    <template v-slot:page-content>
      <div class="support--container">
        <div class="shadow-card hints">
          <div class="section-title">Ответы на популярные вопросы</div>
          <div class="popular-questions mrg-t-15">
            <popular-questions></popular-questions>
          </div>
        </div>
        <div class="shadow-card messages">
          <div class="section-title">Чат с поддержкой</div>
          <div class="support--more mrg-t-15">
            <div @click="loadMore" class="btn btn-sm btn-outline-info">
              Загрузить предыдущие
              <f-awesome icon="arrow-up"></f-awesome>
            </div>
          </div>
          <div class="support--messages">
            <div v-for="item in dataReverse" :key="item.id" class="item" :class="{left: item.is_admin == 1, right: item.is_admin == 0}">
              <div>
                <div class="name">
                  <span v-if="item.is_admin == 1">Сотрудник поддержки</span>
                  <span v-if="item.is_admin == 0">Я</span>
                </div>
                <div class="time">
                  {{item.date}}
                  <span v-if="item.is_admin == 0 && item.seen == 1"><f-awesome icon="check"></f-awesome></span>
                </div>
                <div class="text" v-html="item.message"></div>
              </div>
            </div>
          </div>
          <div class="input-block mrg-t-25">
            <label>Текст сообщения</label>
            <wysiwyg
                v-model="messageModel.model"
                rows="6"
                @focus="messageModel.error = ''"
                @blur="vMessage"
                placeholder="Введите текст..."
            ></wysiwyg>
            <div class="form-error">{{messageModel.error}}</div>
            <div class="hint">Максимальная длина сообщения 1000 символов</div>
          </div>
          <div id="bottom" class="input-block">
            <div @click="sendMessage" class="btn btn-sm btn-success">Отправить</div>
          </div>
        </div>
      </div>
    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src
import supportRepository from "../../repositories/support";
import PanelMainTemplate from "@/components/panel/MainTemplate";
import Validator from "@/components/libraries/Validator";
import PopularQuestions from '../../components/panel/support/PopularQuestions.vue';

const validator = new Validator();

export default {
  name: "Support",
  components: {PanelMainTemplate, PopularQuestions},
  data() {
    return {
      data: [],
      limit: 4,
      page: 0,
      messageModel: {model: '', error: ''},
      getMessageMode: 'more' // more|new - Догружает новые|Обновляет список полностью
    };
  },
  metaInfo: {
    title: "Поддержка - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  watch: {

  },
  computed: {
    validateData() {
      let errorCount = 0;
      this.vMessage().result === "error" ? errorCount++ : "";

      return errorCount;
    },
    dataReverse(){
      let result = [];
      if(this.data.length){
        for(let key in this.data){
          result.push(this.data[key]);
        }
        result.reverse();
      }
      return result;
    }
  },
  methods: {
    vMessage(){
      let validate = validator.validate([
        {
          fieldName: "Текст сообщения",
          value: this.messageModel.model,
          type: "required",
          length: 1500
        },
      ]);
      validate.result === "error"
          ? (this.messageModel.error = validate.message)
          : (this.messageModel.error = "");
      return validate;
    },
    setModeNew(){
      this.getMessageMode = 'new';
      this.page = 0;
    },
    sendMessage(){
      if (this.validateData) {
        return false;
      }
      this.$store.dispatch("startPreloader");

      supportRepository.setUser({ message: this.messageModel.model }).then(() => {
        this.messageModel.model = '';
        this.setModeNew();
        this.getMessages();
        this.$store.dispatch("addNotification", {
          text: 'Сообщение отправлено. Скоро на него ответят',
          time: 4,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    getMessages(){
      this.$store.dispatch("startPreloader");

      supportRepository.getMessages({
        limit: this.limit,
        page: this.page
      }).then(resp => {
        if(this.getMessageMode === 'more'){
          if(resp.data.length){
            for(let key in resp.data){
              this.data.push(resp.data[key]);
            }
          }else{
            if(this.page != 0){
              this.$store.dispatch("addNotification", {
                text: 'Нет сообщений',
                time: 3,
                color: "danger"
              });
            }
          }
        }else if(this.getMessageMode == 'new'){
          this.data = resp.data;
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    loadMore(){
      this.page++;
      this.getMessageMode = 'more';
      this.getMessages();
    }
  },
  created() {
    this.getMessages();
  },
  mounted(){

  }
};
</script>

<style scoped lang="less">
  .support--container{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    flex-direction: row;

    &>div{
      width: 49%;
    }
  }
  .support--more{
    text-align: center;
  }
  .support--messages{
    .item{
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;

      &>div{
        width: 70%;
        padding: 14px;
        margin-top: 8px;
        border-radius: 10px;
        box-sizing: border-box;

        .name{
          font-size: 15px;
          font-weight: 700;
        }
        .time{
          font-size: 12px;
          color: #F97979;
        }
        .text{
          font-size: 14px;
          margin-top: 4px;
        }
      }
    }
    .item.left{
      justify-content: flex-start;

      &>div{
        background-color: rgba(219, 229, 234, 0.8);
      }
    }
    .item.right{
      justify-content: flex-end;

      &>div{
        background-color: rgba(140, 215, 144, 0.90);
      }
    }
  }
  @media (max-width: 700px) {
    .support--container{
      flex-wrap: wrap;

      &>div{
        width: 100%;
      }
    }
    .support--messages{
      .item{

        &>div{
          width: 80%;
        }
      }
    }
  }
</style>
